/* =============================================
   Dr. Chris Landing Page — Interactions
   ============================================= */
(function () {
    'use strict';

    /* -- Scroll Reveal -- */
    function initScrollReveal() {
        var reveals = document.querySelectorAll('.drc-reveal');
        if (!reveals.length) return;
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('drc-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });
        reveals.forEach(function (el) { observer.observe(el); });

        /* Fallback */
        setTimeout(function () {
            reveals.forEach(function (el) { el.classList.add('drc-visible'); });
        }, 3000);
    }

    /* -- Sticky Nav -- */
    function initStickyNav() {
        var nav = document.querySelector('.drc-nav');
        if (!nav) return;
        window.addEventListener('scroll', function () {
            if (window.scrollY > 60) {
                nav.classList.add('drc-nav-scrolled');
            } else {
                nav.classList.remove('drc-nav-scrolled');
            }
        }, { passive: true });
    }

    /* -- Mobile Nav -- */
    function initMobileNav() {
        var toggle = document.querySelector('.drc-nav-toggle');
        var mobileMenu = document.querySelector('.drc-nav-mobile');
        var close = document.querySelector('.drc-nav-mobile-close');
        if (!toggle || !mobileMenu) return;
        toggle.addEventListener('click', function () {
            mobileMenu.classList.add('drc-open');
            document.body.style.overflow = 'hidden';
        });
        if (close) {
            close.addEventListener('click', function () {
                mobileMenu.classList.remove('drc-open');
                document.body.style.overflow = '';
            });
        }
        mobileMenu.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                mobileMenu.classList.remove('drc-open');
                document.body.style.overflow = '';
            });
        });
    }

    /* -- Smooth Scroll -- */
    function initSmoothScroll() {
        document.querySelectorAll('.drc-page a[href^="#"]').forEach(function (a) {
            a.addEventListener('click', function (e) {
                var target = document.querySelector(this.getAttribute('href'));
                if (target) {
                    e.preventDefault();
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        });
    }

    /* -- Marquee duplicate -- */
    function initMarquee() {
        var track = document.querySelector('.drc-marquee-track');
        if (!track) return;
        var items = track.innerHTML;
        track.innerHTML = items + items;
    }

    /* -- Stagger Reveal for grids -- */
    function initStaggerReveal() {
        var grids = document.querySelectorAll('.drc-therapies-grid, .drc-panels-grid, .drc-trust-grid');
        grids.forEach(function (grid) {
            var children = grid.children;
            for (var i = 0; i < children.length; i++) {
                children[i].style.transitionDelay = (i * 0.08) + 's';
            }
        });
    }

    /* -- Counter animation for stats (if any) -- */
    function initCounters() {
        var counters = document.querySelectorAll('[data-drc-count]');
        if (!counters.length) return;
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var el = entry.target;
                    var target = parseInt(el.getAttribute('data-drc-count'), 10);
                    var duration = 2000;
                    var start = 0;
                    var startTime = null;

                    function animate(ts) {
                        if (!startTime) startTime = ts;
                        var progress = Math.min((ts - startTime) / duration, 1);
                        var val = Math.floor(progress * target);
                        el.textContent = val.toLocaleString() + (el.getAttribute('data-drc-suffix') || '');
                        if (progress < 1) requestAnimationFrame(animate);
                    }
                    requestAnimationFrame(animate);
                    observer.unobserve(el);
                }
            });
        }, { threshold: 0.5 });
        counters.forEach(function (el) { observer.observe(el); });
    }

    /* -- Init All -- */
    function init() {
        initScrollReveal();
        initStickyNav();
        initMobileNav();
        initSmoothScroll();
        initMarquee();
        initStaggerReveal();
        initCounters();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
